// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  width: 780,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '9c9eae5e-049a-4f85-957f-917a4c63668e',
      type: 'Container',
      runtimeType: null,
      name: 'popup',
      className: '',
      x: 387,
      y: 128,
      scale: {
        x: 1.2,
        y: 1.2
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '60489db2-3320-4d71-a7da-fca9b016e412',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: -250,
      y: -140,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 500,
      height: 280,
      leftWidth: 100,
      topHeight: 120,
      rightWidth: 100,
      bottomHeight: 120,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Small_Pop_Up_Background',
      parent: '9c9eae5e-049a-4f85-957f-917a4c63668e',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3a19cf17-f64e-4346-b776-d2e05e2e9f10',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'An ad could not be shown. Try again later!',
      localize: true,
      maxWidth: 360,
      maxHeight: 170,
      maxFontSize: 0,
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 2,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 350,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '9c9eae5e-049a-4f85-957f-917a4c63668e',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class AdErrorLayout {
  static raw = raw;
  root: Container;
  popup: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      popup: typeof raw['list'][1];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
